module.exports = __webpack_public_path__ + "img/B.bcae3929.png";